import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_PROFESSIONALDISCIPLINES_LOAD,
    ACTION_PROFESSIONALDISCIPLINES_LOAD_BY_ID,

    ACTION_PROFESSIONALDISCIPLINES_SAVE,

    ACTION_PROFESSIONALDISCIPLINES_CREATE,

    ACTION_PROFESSIONALDISCIPLINES_VALIDATE,

    IProfessionalDisciplineLoadAction,
    IProfessionalDisciplineLoadByIdAction,
    IProfessionalDisciplineLoadFailureAction,
    IProfessionalDisciplineLoadSuccessAction,

    IProfessionalDisciplineSaveAction,
    IProfessionalDisciplineSaveSuccessAction,
    IProfessionalDisciplineSaveFailureAction,

    IProfessionalDisciplineCreateAction,
    IProfessionalDisciplineCreateSuccessAction,
    IProfessionalDisciplineCreateFailureAction,

    IProfessionalDisciplineValidateAction,
    IProfessionalDisciplineValidateSuccessAction,
    IProfessionalDisciplineValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/professionalDisciplines";
import { professionaldisciplinesApi } from "../services/professionalDiscipline";


export const
    getProfessionalDisciplinesEpic = (action$): Observable<IProfessionalDisciplineLoadSuccessAction | IProfessionalDisciplineLoadFailureAction> => {
        return action$
            .ofType(ACTION_PROFESSIONALDISCIPLINES_LOAD)
            .mergeMap((_action: IProfessionalDisciplineLoadAction) => {
                return professionaldisciplinesApi
                    .getProfessionalDisciplines()
                    .map(response =>
                        LoadSuccess(response.professionalDisciplines, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getProfessionalDisciplineByIdEpic = (action$): Observable<IProfessionalDisciplineLoadSuccessAction | IProfessionalDisciplineLoadFailureAction> => {
        return action$
            .ofType(ACTION_PROFESSIONALDISCIPLINES_LOAD_BY_ID)
            .mergeMap((action: IProfessionalDisciplineLoadByIdAction) => {
                return professionaldisciplinesApi
                    .getProfessionalDisciplineById(action.id)
                    .map(response =>
                        LoadSuccess(response.professionalDiscipline, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setProfessionalDisciplineEpic = (action$): Observable<IProfessionalDisciplineSaveSuccessAction | IProfessionalDisciplineSaveFailureAction> => {
        return action$
            .ofType(ACTION_PROFESSIONALDISCIPLINES_SAVE)
            .mergeMap((action: IProfessionalDisciplineSaveAction) => {
                return professionaldisciplinesApi
                    .setProfessionalDiscipline(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.professionalDiscipline, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createProfessionalDisciplineEpic = (action$): Observable<IProfessionalDisciplineCreateSuccessAction | IProfessionalDisciplineCreateFailureAction> => {
        return action$
            .ofType(ACTION_PROFESSIONALDISCIPLINES_CREATE)
            .mergeMap((_action: IProfessionalDisciplineCreateAction) => {
                return professionaldisciplinesApi
                    .createProfessionalDiscipline()
                    .map(response =>
                        CreateSuccess(
                            response.professionalDiscipline,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateProfessionalDisciplineEpic = (action$): Observable<IProfessionalDisciplineValidateSuccessAction | IProfessionalDisciplineValidateFailureAction> => {
        return action$
            .ofType(ACTION_PROFESSIONALDISCIPLINES_VALIDATE)
            .mergeMap((action: IProfessionalDisciplineValidateAction) => {
                return professionaldisciplinesApi
                    .validateProfessionalDiscipline(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.professionalDiscipline, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



